import requests from "./api/base-api";

const WithDrawService = {
    getMyWithDraws: (params)=>requests.getByParams('/withdraw/v1/get-my-withdraws', params),
    settleWithDraw: (data) => requests.post('/withdraw/v1/create-withdraw-request', data),
}
export default WithDrawService;